import { render, staticRenderFns } from "./LatestOrders.vue?vue&type=template&id=e75c1dee"
import script from "./LatestOrders.vue?vue&type=script&lang=js"
export * from "./LatestOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports